import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91d554f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "products" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Últimos productos:"),
  /*#__PURE__*/_createElementVNode("p", null, "Obtén las mejores herramientas y accesorios en nuestra tienda virtual. Nuestra tienda es un proveedor oficial de PPA y ofrecemos garantía en todos nuestros productos."),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://silverwolfstore.uy/shop",
    class: "btn btn-pink",
    target: "_blank"
  }, "VISITAR TIENDA")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductsCarousel = _resolveComponent("ProductsCarousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_ProductsCarousel)
    ])
  ]))
}